import React, { useCallback } from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import InputField from '@commonComponents/formComponents/CustomInputField'
import DatePicker from '@commonComponents/formComponents/CustomDatePicker'

export const InvoiceLine1 = React.memo(
  ({
    dataSource: {
      invoiceId,
      invoiceNumber,
      invoiceDate,
      poNo,
      packQuantity,
      currency,
      invoiceTotal,
      invoiceTotalInCurrency,
      grossMass,
      netMass,
      exchangeRate,
    },
    onChange,
    onBlur,
    currencyList,
    isDMS,
    isInvoiceDisabled
  }) => {
    const onChangeHandler = useCallback(
      ({target:{value, name}}) => onChange({ invoiceId, data: { [name]: value } }),
      [invoiceId, onChange]
    )
    const onDropDownChange = useCallback(
      (e, {value, name}) => {
        onBlur({ invoiceId, data:{[name]: value }}),
        onChange({ invoiceId, data: { [name]: value } })
      },
      [invoiceId, onBlur, onChange]
    )
    const onBlurHandler = useCallback(
      ({target:{value, name}}) => onBlur({ data:{[name]: value}, invoiceId }),
      [invoiceId, onBlur]
    )
    return (
      <>
        <Grid.Column>
          <InputField
            id={`${invoiceId}-invoiceNumber`}
            type='text'
            label="INVOICE_NUMBER"
            value={invoiceNumber}
            name='invoiceNumber'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
            isDisabled={isInvoiceDisabled}
          />
        </Grid.Column>
        <Grid.Column>
          <DatePicker
            id={`${invoiceId}-invoiceDate`}
            type='date'
            label="INVOICE_DATE"
            name='invoiceDate'
            value={invoiceDate}
            onChange={onDropDownChange}
            isDisabled={isInvoiceDisabled}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`${invoiceId}-poNo`}
            type='text'
            label="PO_SHIPMENT"
            value={poNo}
            name='poNo'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
            isDisabled={isInvoiceDisabled}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`${invoiceId}-packQuantity`}
            type='text'
            label="PACK_QTY"
            value={packQuantity}
            name='packQuantity'
            isDisabled={true}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column width='3'>
          <InputField
            id={`${invoiceId}-invoiceTotalInCurrency`}
            type='text'
            label="INV_TOT_VAL_IN_CURR"
            value={invoiceTotalInCurrency}
            isDisabled={true}
            name='invoiceTotalInCurrency'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`${invoiceId}-invoiceTotal`}
            type='text'
            label="INV_TOT_VAL"
            boxNumber={`${isDMS ? '4/11' : ''}`}
            value={invoiceTotal}
            isDisabled={true}
            name='invoiceTotal'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column width='2'>
          <DropDown
            id={`${invoiceId}-currency`}
            label="CURRENCY"
            boxNumber={`${isDMS ? '4/10' : ''}`}
            labelClass='text-none'
            direction='left'
            data={currencyList}
            clearable
            value={currency}
            text={currency}
            name='currency'
            onChange={onDropDownChange}
            isDisabled={isInvoiceDisabled}
          />
        </Grid.Column>
        <Grid.Column width='2'>
          <InputField
            id={`${invoiceId}-exchangeRate`}
            type='text'
            boxNumber={`${isDMS ? '4/15' : ''}`}
            label="EXCHANGE_RATE"
            isDisabled={true}
            value={exchangeRate}
            name='exchangeRate'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`${invoiceId}-grossMass`}
            type='text'
            label="GROSS"
            value={grossMass}
            isDisabled={true}
            name='grossMass'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column>
          <InputField
            id={`${invoiceId}-netWt`}
            type='text'
            label="NET"
            isDisabled={true}
            value={netMass}
            name='netMass'
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
      </>
    )
  }
)

